<template>
    <div class="scrollbar">
        <div class="col-12 inMiddle-area mt-4">
            <div class="row">
				<div class="col-12 col-md-12 acountStatus">
					<div class="tpSearch position-relative">
						
						<app-top-header-title  ref="form" :listStatusFilter="'WITHDRAWAL-COMMISSION-LISTING'"></app-top-header-title>
				   </div>
					<div class="scrollable-table">
					 <div class="scrollable-x">
						<table class="table table-striped focus-on withdrawalTable">
							<thead>
								<tr>
									<th>Username</th>
									<!--<th>Email</th>-->
									<th>Amount</th>
									<th>Currency</th>
									<th>Type</th>
									<th>Method</th>
									<th>Status</th>
									<th>Created</th>
								</tr>
							</thead>
							<tbody v-if="(!pageLoader && withdrawalCommList != '' && withdrawalCommList.totalRecords > 0)">
								<tr v-for="(list,index) in withdrawalCommList.records" >
									<td>{{list.username}}</td>
									<!--<td>{{list.email}}</td>-->
									<td>{{list.amount}}</td>
									<td>{{list.currency}}&nbsp;<img class="flagIcon" :src="'../../../../static/fxView/images/'+currency[list.currency]" alt="Icon"></td>
									<td>{{withdrawalType[list.type]}}</td>
									<td>{{withdrawalMethod[list.withdrawal_method]}}</td>
									<td><span class="statusTable" :class="(parseInt(list.withdrawal_status) > 0 )?  ((parseInt(list.withdrawal_status) == 1)? 'success':'rejected')  : 'open'">{{withdrawalStatus[list.withdrawal_status]}}</span></td>
									<td>{{list.created | moment("DD-MM-YYYY")}}</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
							    <td colspan="8" class="p-0">
								<loader :pageloader_value="pageLoader" :type="'table'" :colspan="'7'" :list="withdrawalCommList"></loader>
							    </td>
							   </tr>
							</tbody>
						</table>
					 </div>
					</div>
					<app-pagination :getList="withdrawalCommList" :pageLimit_parent="pageLimit"></app-pagination>
				</div>
			</div>
        </div>
    </div>
</template>
<script>  
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'WITHDRAWAL-COMMISSION-LISTING',
        mixins: [fxViewMixins],
        data () {
            return {
                pageTitle: this.$options.name,
				"pageLoader" : false,

                'search' : '',
                page :'1',
                pageLimit : 15,
				listStatus : ''
            }
        },
		methods:{
			listing(){
                let inputJson = {
                    'globalParams' : {
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: this.pageLimit,
                    } ,'localParams' : {'parameter' : this}
                }
                this._runGetWithdrawalCommList(inputJson)
            }
		},
		created(){
            this.setData('WITHDRAWAL-HISTORY')
			this.listing()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/withdrawal/withdrawal_commission_listing.vue